import { SelectFields } from '@repo/toolkit/types'
import { PaginationResponse } from '@repo/ui/data-table'

import { PaymentRecord } from '../../lib/types/models/payment-record/payment-record'
import { FieldsSelector } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPaymentRecords<T extends FieldsSelector<PaymentRecord>>(
  input: { enrollmentId: number },
  fields: T
) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.enrollments.getPaymentRecords.url, {
          id: input.enrollmentId
        }),
        { fields }
      )
    )
    .get<PaginationResponse<SelectFields<PaymentRecord, T>>>()
}
